module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/hr.html
// module id = 446
// module chunks = 0